'use client';
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

type Company = {
  name: string;
  logo: string;
  link: string;
};

type CompanyCarouselProps = {
  companies: Company[];
};

const CompanyCarousel: React.FC<CompanyCarouselProps> = ({ companies }: CompanyCarouselProps) => {
  const [shuffledCompanies, setShuffledCompanies] = useState<Company[]>([]);

  // Shuffle companies on mount
  useEffect(() => {
    const shuffled = [...companies].sort(() => Math.random() - 0.5);
    setShuffledCompanies(shuffled);
  }, [companies]);

  // Slider settings
  // Slider settings
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 5, // Default for large screens
  slidesToScroll: 1,
  autoplay: true, // Enable auto-scroll
  autoplaySpeed: 3000, // Auto-scroll every 3 seconds
  responsive: [
    {
      breakpoint: 1024, // Large screens
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 768, // Medium screens
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 480, // Small screens
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

  return (
    <div className="w-full overflow-hidden py-6">
      <Slider {...settings}>
        {shuffledCompanies.map((company, index) => (
          <div key={index} className="flex flex-col items-center p-4">
            <a
              href={company.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center"
            >
              <img
                src={company.logo}
                alt={company.name}
                className="w-24 h-24 object-contain mb-2"
              />
              <h3 className="text-lg font-semibold text-center text-[var(--color-brand)]">
                {company.name}
              </h3>
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CompanyCarousel;